import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StudyModuleRoutingModule } from './study-module-routing.module';
import { StudyModuleComponent } from './study-module.component';
import { StructureUnitComponent } from './structure-unit.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';


@NgModule({
  declarations: [
    //StudyModuleRoutingComponent,
    StudyModuleComponent,
    StructureUnitComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
   // StructureUnitComponent,
    StudyModuleRoutingModule
  ]
})
export class StudyModuleModule { }
/*
declarations: [
    CourseComponent,
    ProgrammeComponent,
    RealizationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    CourseRoutingModule
  ],
  providers: [
    CourseService
  ]*/